<template>
	<el-drawer :title="data && data.id ? '编辑滞留单' : '新建滞留单'" :visible.sync="drawerShow" :wrapperClosable="false"
		:destroy-on-close="true" size="400px" @close="close" v-loading="dataLoading">
		<div class="drawer-content">
			<el-form :model="formData" ref="formData" label-position="top" class="MT10" :rules="rules"
				:disabled="data && data.status === 2 || data && data.status === 3 ">
				<el-form-item prop="title">
					<span slot="label">滞留款标题：<small><span
								class="color-warning">结算时会体现在额外技术服务费，尽量写清楚</span></small></span>
					<el-input v-model="formData.title" placeholder="请输入滞留款标题" maxlength="150"></el-input>
				</el-form-item>
				<el-form-item prop="receivableUserId">
					<span slot="label">结款方用户：<small><span class="color-warning">可以输入名称，ID</span></small></span>
					<el-select v-model="formData.receivableUserId" filterable remote placeholder="请输入结款方"
						:remote-method="searchUser" :loading="userLoading" size="medium">
						<el-option v-for="item in userList" :key="item.id"
							:label="`[${$userType.get(item.userType)}]${item.userName}`" :value="item.userId">
						</el-option>
					</el-select>
					<small v-for="item in userList">
						<span v-if="item.contactNo" class="MR20">合同编号：{{item.contactNo}}</span>
						<span v-if="item.accountName">账户名：{{item.accountName}}</span>
					</small>
				</el-form-item>
				<el-form-item prop="amount" label="金额:">
					<span slot="label">金额：<small><span class="color-warning">为正是扣款，为负是补款</span></small></span>
					<el-input-number style="width:100%" v-model="formData.amount" :precision="2"></el-input-number>
				</el-form-item>
				<el-form-item prop="remark" label="备注:">
					<span slot="label">备注：<small><span class="color-warning">仅后台查看</span></small></span>
					<el-input v-model="formData.remark" placeholder="请输入仅后台查看" maxlength="250" type="textarea" :rows="12"
						show-word-limit></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">关闭</el-button>
			<el-button type="primary" @click="submitForm()" :loading="btnLoading"
				:disabled=" data && data.status === 2 || data && data.status === 3 ">确认</el-button>
		</div>
	</el-drawer>
</template>

<script>
	const defaultData = {
		id: "",
		title: "",
		receivableUserId: "",
		amount: undefined,
		remark: ""
	}
	export default {
		components: {},
		data() {
			return {
				drawerShow: false,
				btnLoading: false,
				userLoading: false,
				dataLoading: false,
				formData: {
					...defaultData
				},
				data: null,
				userList: [],
				rules: {
					title: [{
						required: true,
						message: "标题不能为空！"
					}],
					receivableUserId: [{
						required: true,
						message: "结款方用户不能为空！"
					}],
					amount: [{
						required: true,
						message: "金额不能为空！"
					}],
				},
			}
		},
		methods: {
			close() {
				this.drawerShow = false;
				this.formData = {
					...defaultData
				};
				this.data = null
				this.userList = []
			},
			show(data) {
				this.data = data
				this.formData = {
					...data
				};

				if (data && data.receivableUserId) {
					this.$nextTick(() => {
						this.searchUser(data.receivableUserId)
					})
				}
				this.drawerShow = true;
			},

			// 搜索用户
			async searchUser(query) {
				if (query !== "") {
					this.userLoading = true;
					const res = await this.$request({
						url: '/retention/payment/user/search',
						method: 'POST',
						params: {
							keyWord: query
						}
					}).finally(() => {
						this.userLoading = false;
					});

					const {
						state,
						result
					} = res.data;

					if (state == 1 && result) {
						this.userList = result;

					}
				}
			},
			submitForm() {
				this.$refs["formData"].validate((valid) => {
					if (valid) {
						this.btnLoading = true;
						this.$request({
								url: '/retention/payment/save',
								data: {
									...this.formData
								},
								method: "post",
							})
							.then((res) => {
								const {
									state,
									msg
								} = res.data;
								if (state == 1) {
									this.$emit('onUpdate');
									this.close();
								} else {
									this.$message.error(msg || "操作失败,请重试");
								}
							})
							.catch(() => {
								self.$message.error("操作失败,请重试");
							})
							.finally(() => {
								this.btnLoading = false;
							});
					} else {
						return false;
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.font10 {
		font-size: 8px;
	}

	.tdc {
		font-size: 16px;
		font-weight: bold;
	}

	.shortUrl {
		margin-top: 15px;
	}

	.url {
		margin-top: 5px;
		color: #999
	}

	::v-deep .el-card__body {
		padding: 10px
	}

	.auditTotalNum {
		margin-top: 20px;

		.title {

			font-weight: bold;

			small {
				color: #999
			}
		}

		.num {
			margin-top: 10px;
			color: #999;

			.color-danger {
				font-size: 18px;
			}

			.color-blue {
				font-size: 14px;
			}
		}
	}

	.copyTool {
		opacity: 0;
		filter: alpha(opacity=0);
		// height: 1px;
	}
</style>